import Vue from 'vue'
import Router from 'vue-router'
import App from '@/App'
import Landing from '../views/Landing'
import SignUp from '../views/SignUp'
import Profile from '../views/Profile'
import SignIn from '../views/SignIn'
import { getQueryString, fixSiteIndexURL } from '@/alias/utils';
import { getWebStatusReady } from '@/api/index';
import { setStorage, getStorage } from '@/alias/store'


import { getPinYinTranslation } from "@/api/index";

let translateLastName = async function() {

    let param = { "text" : '中国' };
    let res = await getPinYinTranslation(param);
    console.log(res, 'res')
}

Vue.use(Router)
let token = getStorage('ssoToken')
const routes = [
    {
        path: '/',
        name: 'App',
        component: App,
        redirect: token ? '/Profile':'/Landing'
    },
    {
        path: '/Landing',
        name: 'Landing',
        component: Landing
    },
    {
        path: '/Profile',
        name: 'Profile',
        component: Profile,
        meta: {
            title: '我的优悦会账户',
            keepAlive: false
        }
    },
    {
        path: '/SignUp',
        name: 'SignUp',
        component: SignUp,
        meta: {
            title: '加入IHG优悦会',
            keepAlive: true
        }
    },
    {
        path: '/SignIn',
        name: 'SignIn',
        component: SignIn,
        meta: {
            title: '登录IHG优悦会',
            keepAlive: false
        }
    }

]

const router = new Router({
  routes: routes
})


router.beforeEach((to, from, next) => {
    let token = getStorage('ssoToken')

    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if(!sessionStorage.getItem('userInfo')) {
        if(to.path !== '/Landing') {
            next({
                path: '/Landing'
            })
        } else {
            next()
        }
    }
    else if(!token || token === null) {
        // if(from.path !== '/SignUp') {
            next();
        // } else {
        //     next()
        // }
    }
    else {
        if(to.path !== '/Profile') {
            next({
                path: '/Profile'
            });
        } else {
            next();
        }

        next()
    }

})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js